export const FETCH_ALL_DIRECT_BILLING_DATA_REQUEST = 'FETCH_ALL_DIRECT_BILLING_DAT_REQUEST';
export const FETCH_ALL_DIRECT_BILLING_DATA_SUCCESS = 'FETCH_ALL_DIRECT_BILLING_DATA_SUCCESS';
export const FETCH_ALL_DIRECT_BILLING_DATA_FAILURE = 'FETCH_ALL_DIRECT_BILLING_DATA_FAILURE';

export const FETCH_DIRECT_BILLING_DATA_BY_ID_REQUEST = 'FETCH_DIRECT_BILLING_DATA_BY_ID_REQUEST';
export const FETCH_DIRECT_BILLING_DATA_BY_ID_SUCCESS = 'FETCH_DIRECT_BILLING_DATA_BY_ID_SUCCESS';
export const FETCH_DIRECT_BILLING_DATA_BY_ID_FAILURE = 'FETCH_DIRECT_BILLING_DATA_BY_ID_FAILURE';

export const CREATE_DIRECT_BILLING_MASTER_USERFORM = 'CREATE_DIRECT_BILLING_MASTER_USERFORM';

export const CREATE_DIRECT_BILLING_REQUEST = 'CREATE_DIRECT_BILLING_REQUEST';
export const CREATE_DIRECT_BILLING_SUCCESS = 'CREATE_DIRECT_BILLING_SUCCESS';
export const CREATE_DIRECT_BILLING_FAILURE = 'CREATE_DIRECT_BILLING_FAILURE';

export const UPDATE_DIRECT_BILLING_REQUEST = 'UPDATE_DIRECT_BILLING_REQUEST';
export const UPDATE_DIRECT_BILLING_SUCCESS = 'UPDATE_DIRECT_BILLING_SUCCESS';
export const UPDATE_DIRECT_BILLING_FAILURE = 'UPDATE_DIRECT_BILLING_FAILURE';

export const DELETE_DIRECT_BILLING_DATA_REQUEST = 'DELETE_DIRECT_BILLING_DATA_REQUEST';
export const DELETE_DIRECT_BILLING_DATA_SUCCESS = 'DELETE_DIRECT_BILLING_DATA_SUCCESS';
export const DELETE_DIRECT_BILLING_DATA_FAILURE = 'DELETE_DIRECT_BILLING_DATA_FAILURE';

export const DIRECT_BILLING_RESET_USERFORM = 'DIRECT_BILLING_RESET_USERFORM';
export const DIRECT_BILLING_NAVIGATE_TO_DETAIL_TAB = 'DIRECT_BILLING_NAVIGATE_TO_DETAIL_TAB';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const NAVIGATE_DIRECT_BILLING = 'NAVIGATE_DIRECT_BILLING';

export const NAVIGATE_DIRECT_BILLING_DETAILS = 'NAVIGATE_DIRECT_BILLING_DETAILS';
export const DIRECT_BILLING_NAVIGATE_TO_DETAIL_REVERSE = 'DIRECT_BILLING_NAVIGATE_TO_DETAIL_REVERSE';

export const CONVERT_DIRECT_BILL_ENTRY_TO_BE_REQUEST = 'CONVERT_DIRECT_BILL_ENTRY_TO_BE_REQUEST';
export const CONVERT_DIRECT_BILL_ENTRY_TO_BE_SUCCESS = 'CONVERT_DIRECT_BILL_ENTRY_TO_BE_SUCCESS';
export const CONVERT_DIRECT_BILL_ENTRY_TO_BE_FAILURE = 'CONVERT_DIRECT_BILL_ENTRY_TO_BE_FAILURE';

export const FETCH_DIRECT_BILLING_BRN_NO_REQUEST = 'FETCH_DIRECT_BILLING_BRN_NO_REQUEST';
export const FETCH_DIRECT_BILLING_BRN_NO_SUCCESS = 'FETCH_DIRECT_BILLING_BRN_NO_SUCCESS';
export const FETCH_DIRECT_BILLING_BRN_NO_FAILURE = 'FETCH_DIRECT_BILLING_BRN_NO_FAILURE';

export const FETCH_DIRECT_BILLING_PROGRAM_ID_REQUEST = 'FETCH_DIRECT_BILLING_PROGRAM_ID_REQUEST';
export const FETCH_DIRECT_BILLING_PROGRAM_ID_SUCCESS = 'FETCH_DIRECT_BILLING_PROGRAM_ID_SUCCESS';
export const FETCH_DIRECT_BILLING_PROGRAM_ID_FAILURE = 'FETCH_DIRECT_BILLING_PROGRAM_ID_FAILURE';
